import { readSessionRole } from '@/auth/tabStorage';

// frontendV2 lives under /v2/ on this domain (#938); locally it runs on its own port, set by VITE_NEW_APP_URL.
const NEW_APP_BASE_PATH = '/v2/';
const DEFAULT_PAGE = 'dashboard';

// The pages both apps have; any other page opens the new app's dashboard.
const NEW_APP_PAGES: ReadonlyArray<readonly [ReadonlyArray<string>, string]> = [
  [['/dashboard'], 'dashboard'],
  [['/creatives'], 'creatives'],
  [['/landings', '/admin/landings'], 'landings'],
];

const newAppPage = (legacyPath: string): string =>
  NEW_APP_PAGES.find(([paths]) => paths.includes(legacyPath))?.[1] ?? DEFAULT_PAGE;

/**
 * Hidden on prod until frontendV2 is deployed there (#938). STAGING is a build-time literal, so showing it on prod
 * is a code change and a release, not a setting.
 */
export const isNewInterfaceEnabled = (): boolean => process.env.STAGING !== 'prod';

/** The same page in the new app, under the role this tab works as (both apps use the same role names). */
export const newInterfaceUrl = (legacyPath: string, role: string): string => {
  const origin = import.meta.env.VITE_NEW_APP_URL ?? window.location.origin;
  return `${origin}${NEW_APP_BASE_PATH}${role}/${newAppPage(legacyPath)}`;
};

/**
 * Opens the current page in the new app. The new app keeps its own session: without one it asks to sign in
 * once and then opens this page. Sharing this tab's tokens with it logged both apps out on the next refresh.
 */
export const openNewInterface = (legacyPath: string): void => {
  window.location.assign(newInterfaceUrl(legacyPath, readSessionRole() ?? ''));
};
